<template>

<div>
  <div v-if="selectedCompetition" class="edit-form">
    <h4>Stevne</h4>
    <div>
      <label><strong>Navn:</strong></label>
      <span :style="{ textDecoration: selectedCompetition.hidden ? 'line-through' : 'none' }">
        {{ selectedCompetition.name || "NoName" }}
      </span>
    </div>
    <div>
      <label><strong>Valgte funksjoner:</strong></label>
      <ul>
        <li v-for="func in selectedCompetition.selectedFunctions" :key="func.id">
          {{ func.name }}
        </li>
      </ul>
    </div>
    <div>
      <label><strong>Stevnenummer:</strong></label> {{ selectedCompetition.id }}
    </div>
    <div v-if="selectedCompetition.hash">
      <label><strong>Stevnekode:</strong></label> {{ selectedCompetition.hash }}
    </div>
    <div>
      <label><strong>Dato:</strong></label> {{ selectedCompetition.date_start || "" }} - {{ selectedCompetition.date_end || "" }}
    </div>
    <div>
      <label><strong>Nivå:</strong></label> {{ selectedCompetition.level || ""}}
    </div>
    <div>
      <label><strong>Arrangør:</strong></label> {{ selectedCompetition.organizer || ""}}
    </div>
    <div>
      <label><strong>Web:</strong></label>
      <a :href="selectedCompetition.external_webpage" target="_blank">
        {{ selectedCompetition.external_webpage || "" }}
      </a>
    </div>
    <div v-if="selectedCompetition.venue_id !== '1' && selectedCompetition.venue_id !== 1">
      <label><strong>Stadion:</strong></label> {{ selectedCompetition.venue_id || ""}}
    </div>
    <div v-if="checkRole(['frisys_admin',{name:'competition_admin', verify_competition:true}])">
      <label><strong>Skjul m. opprop e. fø. res.:</strong></label>{{ selectedCompetition.hideMissingCallroomAfterFirstResult ? "Valgt" : "Ikke valgt" }}
    </div>
    <!-- <div>
      <label><strong>Tilhørighet:</strong></label> {{ selectedCompetition.affiliation && selectedCompetition.affiliation.field || "" }} = {{ selectedCompetition.affiliation && selectedCompetition.affiliation.title || "" }}
    </div> -->
    <!-- <div>
      <label><strong>Publiseringsdato:</strong></label> {{ selectedCompetition.publishDate | formatDate_onlyDate }}
    </div>
    <div>
      <label><strong>Admin godkjennelse:</strong></label> {{ selectedCompetition.adminApproved ? "Godkjent" : "Venter" }}
    </div> -->
  </div>
</div>
</template>

<script>
import MyComputed from "../myComputed";
import CompetitionDataService from "../services/CompetitionDataService";

export default {
  mixins: [MyComputed],
  name: "competition",
  data() {
    return {
      message: ''
    };
  },
  methods: {

    updatePublished(status) {
      // var data = {
      //   id: this.currentCompetition._id,
      //   title: this.currentCompetition.title,
      //   description: this.currentCompetition.description,
      //   published: status
      // };
      this.currentCompetition.published=status

      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          this.currentCompetition.published = status;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateCompetition() {
      CompetitionDataService.update(this.currentCompetition.id, this.currentCompetition)
        .then(response => {
          console.log(response.data);
          this.message = 'The competition was updated successfully!';
        })
        .catch(e => {
          console.log(e);
        });
    },

    deleteCompetition() {
      CompetitionDataService.delete(this.currentCompetition.id)
        .then(response => {
          console.log(response.data);
          this.$router.push({ name: "competitions" });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  filters: {
    formatDate_onlyDate(value) {
      const date = new Date(value);
      return date.toLocaleDateString("no-NO", { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  },
  mounted() {
    console.log("Competition - mounted")
    this.message = '';
    console.log("selectedCompetition:")
    console.log(this.selectedCompetition)
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        console.log(`Watch triggered: ${toParams}  - ${previousParams}`)
        this.getCompetition(this.$route.params.competition_id);
        // react to route changes...
      }
    )
  }
};
</script>

<style>
.edit-form {
  max-width: 300px;
  margin: auto;
}
</style>
